import produce from 'immer';
import {
  WALLET_TRANSACTIONLOG_LIST_REQUEST, WALLET_TRANSACTIONLOG_LIST,
  SET_TOTAL_COUNT, SET_WALLET_TRANSACTIONLOG_PAGINATION, WALLET_TRANSACTIONLOG_PAGE_RESET,
} from '../../constants/log/walletTransactionLogConstants';
import moment from 'moment';

const initialState = {
  page: 1,
  pageLength: 10,
  beginDate: moment().utc().subtract(3, 'days').format('YYYY-MM-DDT00:00:00'),
  endDate: moment().utc().format('YYYY-MM-DDT23:59:59'),
  searchCode: '',
  searchString: '',
  totalCount: 0,
};

const walletTransactionLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case WALLET_TRANSACTIONLOG_LIST_REQUEST:
      break;
    case WALLET_TRANSACTIONLOG_LIST:
      draft.list = action.list;
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_WALLET_TRANSACTIONLOG_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.beginDate = action.beginDate;
      draft.endDate = action.endDate;
      draft.searchCode = action.searchCode;
      draft.searchString = action.searchString;
      break;
    case WALLET_TRANSACTIONLOG_PAGE_RESET:
      draft.page = 1;
      break;
    default:
      break;
  }
});

export default walletTransactionLogReducer;
